import React from 'react';
import { Mediator } from '@spotahome/soyuz-mediator';

import { loginButtonShape } from '../HeaderContainer/shapes/login.shape';

import { COMMON_LOGIN_MODAL } from '../utils/constants';

import { USER_NOT_REQUESTED, MODAL_SIGNUP, MODAL_LOGIN } from './constants';

import LoginLoadingButton from './LoginLoadingButton';
import NotLogged from './NotLogged';
import LoggedIn from './LoggedIn';

const triggerOpenModal = (action, eventAction) => {
  Mediator.publish(COMMON_LOGIN_MODAL, {
    initialAction: action,
    events: {
      open: {
        eventCategory: 'signup/login modal',
        eventAction: `${eventAction} button`,
        eventLabel: 'open'
      },
      close: {
        eventCategory: 'signup/login modal',
        eventAction: 'Signup/Login button',
        eventLabel: 'close'
      }
    }
  });
};

const LoginButton = ({
  isMobile,
  logoutPath,
  userInfo,
  color,
  typeMenu,
  userAreaPath,
  searchPreferencePath,
  myProfilePath,
  myReferralsPath,
  myPaymentsPath,
  newHeaderSignupLogin,
  isTopTenantVariant
}) => {
  const renderLoginButton = () =>
    userInfo ? (
      <LoggedIn
        isMobile={isMobile}
        typeMenu={typeMenu}
        userName={userInfo.fullname}
        myProfilePath={myProfilePath}
        myReferralsPath={myReferralsPath}
        myPaymentsPath={myPaymentsPath}
        userAreaPath={userAreaPath}
        searchPreferencePath={searchPreferencePath}
        logoutPath={logoutPath}
        isTopTenantVariant={isTopTenantVariant}
      />
    ) : (
      <NotLogged
        isMobile={isMobile}
        color={color}
        typeMenu={typeMenu}
        newHeaderSignupLogin={newHeaderSignupLogin}
        onHandleSignUp={() => triggerOpenModal(MODAL_SIGNUP, 'Signup')}
        onHandleLogIn={() => triggerOpenModal(MODAL_LOGIN, 'Login')}
      />
    );

  return userInfo !== USER_NOT_REQUESTED ? (
    renderLoginButton()
  ) : (
    <LoginLoadingButton isMobile={isMobile} />
  );
};

LoginButton.propTypes = {
  ...loginButtonShape
};

LoginButton.defaultProps = {
  isMobile: false,
  logoutPath: '#',
  userInfo: null,
  color: 'dark',
  typeMenu: 'menu-transparent',
  userAreaPath: '',
  searchPreferencePath: '',
  myProfilePath: '',
  myReferralsPath: '',
  myPaymentsPath: '',
  newHeaderSignupLogin: false
};

export default LoginButton;
